import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiGetOrderAgreement, apiHasOtherProblemPack } from '../../api';
import main from '../../main';
import { showConfirm, showToast } from '../../utils/utils';
import RadioBox from '../radioBox';
import './index.scss';

interface Props {
  /** 协议状态变化回调，返回是否已勾选 */
  onAgreeChange?: (agreed: boolean) => void;
  /** 是否启用"其他问题"入口查询（按设备当前资费判断；不传则不展示入口） */
  enableOtherProblem?: boolean;
}

export default function OrderAgreement({ onAgreeChange, enableOtherProblem }: Props) {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [agreed, setAgreed] = useState(true);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [agreementName, setAgreementName] = useState('');
  const [agreementContent, setAgreementContent] = useState('');
  // 是否展示"其他问题"入口（当前套餐配置了生效的其他问题(套餐)活动）
  const [showOtherProblem, setShowOtherProblem] = useState(false);

  useEffect(() => {
    loadAgreement();
  }, []);

  async function loadAgreement() {
    try {
      let deptId = main.currentEm?.deptId || main.deptId;
      if (!deptId) return;
      let res = await apiGetOrderAgreement(deptId);
      let data = res.data;
      if (data.code === 200 && data.data) {
        let info = data.data;
        if (info.orderAgreementStatus === 'Y') {
          setVisible(true);
          setAgreementName(info.orderAgreementName || '订购须知');
          setAgreementContent(info.orderAgreementContent || '');
          setAgreed(true);
          onAgreeChange?.(true);
          if (enableOtherProblem) {
            loadOtherProblemFlag();
          }
        }
      }
    } catch (e) {}
  }

  // 判断设备当前资费是否配置了其他问题(套餐)活动
  async function loadOtherProblemFlag() {
    try {
      let res = await apiHasOtherProblemPack(main.currentEm?.cardProductId);
      let data = res.data;
      if (data.code === 200 && data.data === true) {
        setShowOtherProblem(true);
      }
    } catch (e) {}
  }

  async function handleCheckboxChange() {
    if (agreed) {
      // 取消勾选 -> 弹窗确认
      let res = await showConfirm({
        title: '温馨提示',
        content: `取消勾选《${agreementName}》将无法继续订购套餐加油包/权益包!`,
        confirmBtnText: '关闭弹窗',
        cancelBtnText: '继续取消勾选',
        closeBtnAsConfirm: true,
      });
      if (res === 0) {
        // 继续取消勾选
        setAgreed(false);
        onAgreeChange?.(false);
      }
      // res === 1 关闭弹窗，保持勾选
    } else {
      // 重新勾选
      setAgreed(true);
      onAgreeChange?.(true);
    }
  }

  if (!visible) return null;

  return (
    <>
      <div className="order-agreement-bar">
        <div className="order-agreement-check" onClick={handleCheckboxChange}>
          <RadioBox value={agreed} />
          <span className="order-agreement-text">
            我已阅读并同意
            <span
              className="order-agreement-link"
              onClick={(e) => {
                e.stopPropagation();
                setDrawerVisible(true);
              }}
            >
              《{agreementName}》
            </span>
          </span>
        </div>
      </div>

      {/* 抽屉遮罩 */}
      {drawerVisible && (
        <div className="order-agreement-drawer-mask" onClick={() => setDrawerVisible(false)}>
          <div
            className={`order-agreement-drawer ${drawerVisible ? 'show' : ''}`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="order-agreement-drawer-header">
              <div className="order-agreement-drawer-title">{agreementName}</div>
              <img
                className="order-agreement-drawer-close"
                src="/pic/icon_close_black.png"
                alt=""
                onClick={() => setDrawerVisible(false)}
              />
            </div>
            <div
              className="order-agreement-drawer-content"
              dangerouslySetInnerHTML={{ __html: (agreementContent || '').replace(/\n/g, '<br/>') }}
            />
            {showOtherProblem && (
              <div
                className="order-agreement-other-problem"
                onClick={() => navigate('/select-pack', { state: { source: 'otherProblem' } })}
              >
                <span className="order-agreement-other-problem-text">其他问题</span>
                <span className="order-agreement-other-problem-arrow">›</span>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
